import React from 'react'
import FormTitle from '../../../../components/FormTitle';
import Input from '../../../../components/FormInputs';

interface AddressDetailsProps {
    register: any;
    errors: any;
    setValue: any;
    }

const AddressDetails:React.FC<AddressDetailsProps> = ({errors,register}) => {

  return (
    <div className="bg-white p-4 rounded-[20px] mt-2">
        <FormTitle title="Address Details" />
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-1">
            <Input
                label="Address Line 1"
                name="addressDetails.addressLine1"
                errors={errors}
                register={register}
                placeholder="Enter your address line 1"
                type="text"
            />
            <Input
                label="Address Line 2"
                name="addressDetails.addressLine2"
                errors={errors}
                register={register}
                placeholder="Enter your address line 2"
                type="text"
            />
            <Input
                label="City"
                name="addressDetails.city"
                errors={errors}
                register={register}
                placeholder="Enter your city"
                type="text"
            />
            <Input
                label="State"
                name="addressDetails.state"
                errors={errors}
                register={register}
                placeholder="Enter your state"
                type="text"
            />
            <Input
                label="Country"
                name="addressDetails.country"
                errors={errors}
                register={register}
                placeholder="Enter your country"
                type="text"
            />
            <Input
                label="Pincode"
                name="addressDetails.pincode"
                errors={errors}
                register={register}
                placeholder="Enter your pincode"
                type="text"
            />
        </div>

    </div>
  )
}

export default AddressDetails